import React from 'react'
import PropTypes from 'prop-types'
import {DatePicker} from "antd"
import moment from "moment"

FilterMultiDate.propTypes = {
    receptionDateFrom: PropTypes.object,
    receptionDateTo: PropTypes.object,
    onChangeFrom: PropTypes.func.isRequired,
    onChangeTo: PropTypes.func.isRequired
}

function FilterMultiDate(props) {
    const {receptionDateFrom, receptionDateTo, onChangeFrom, onChangeTo} = props

    const _onChangeDateFrom = (value, dateString) => {
        if (value) {
            if (typeof onChangeFrom === 'function') {
                onChangeFrom(value)
            }
        }
    }

    const _onChangeDateTo = (value, dateString) => {
        if (value) {
            if (typeof onChangeTo === 'function') {
                onChangeTo(value)
            }
        }
    }

    return (
        <div className="FilterMultiDate">
            <div className="FilterDateFrom">
                <label htmlFor="from">Thời gian gọi(từ)</label>
                <DatePicker
                    allowClear={false}
                    id="from"
                    value={!!receptionDateFrom ? moment(receptionDateFrom, 'DD/MM/YYYY') : receptionDateFrom}
                    format="DD/MM/YYYY"
                    onChange={_onChangeDateFrom}
                />
            </div>

            <div className="FilterDateFrom">
                <label htmlFor="to">Thời gian gọi(đến)</label>
                <DatePicker
                    id="to"
                    allowClear={false}
                    value={!!receptionDateTo ? moment(receptionDateTo, 'DD/MM/YYYY') : receptionDateTo}
                    format="DD/MM/YYYY"
                    onChange={_onChangeDateTo}
                />
            </div>
        </div>
    )
}

export default FilterMultiDate
